import React, { useContext, useState } from "react";
import { TransButtonPrimaryWithSpinner } from "../../Atoms/Buttons";
import { ConfirmDialog, useModalState } from "../../Molecules/Dialogs";
import { Icon } from "../../Atoms/Icons";
import Moment from "react-moment";
import {
  patchFormSubmission,
  patchFormSubmissionValues,
} from "../../Service/restapi/formSubmissionService";
import { Trans } from "@lingui/react";
import { TransTextInputField } from "../../Atoms/InputFields";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";
import ContractDrawSign from "../Contract/ContractDrawSign";
import ProviderSignature from "../Contract/ProviderSignature";
import Agreements from "../Contract/Agreements";
import { FormSubmissionS } from "../../Service/FormSubmissionS";
import { ContactS } from "../../Service/restapi/contactService";
import { openCustomerAddressModal } from "../../Modals/CustomerAddressModal";
import {
  getContactDescription,
  getContactName,
  isDefined,
} from "../../Utils/utils";
import { Group, Paper, Space } from "@mantine/core";
import moment from "moment";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";

export default ({
  questionnaire,
  formSubmission,
  reload,
  resource,
  values = {},
  handleChange,
  patchSubmissionValue,
}) => {
  const { show, toggle } = useModalState(false);
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, questionnaire.language);
  const {
    loading: resourceLoading,
    customerContact,
    partnerIncluded,
    setCustomerContact,
  } = useContext(ResourceContext);
  const signingRequired =
    questionnaire &&
    questionnaire.contractSign &&
    questionnaire.contractSign !== "NONE";
  const customerSignType =
    questionnaire &&
    (questionnaire.customerSignType || questionnaire.contractSign);
  const { customerSignedAt, customerPartnerSignedAt } = formSubmission;
  const { signImage, partnerSignImage, sign, partnerSign } = values;
  const isPartnerIncluded = partnerIncluded && customerContact;
  const customerDescription = customerContact
    ? getContactDescription(customerContact)
    : "Kunde";

  if (signingRequired && resourceLoading) {
    return <LoadingAnimation />;
  }

  const collectSignatures = () => {
    if (customerSignType === "TEXT_FIELD") {
      return {
        sign,
        partnerSign: isPartnerIncluded ? partnerSign : undefined,
      };
    }
    return {
      signImage,
      partnerSignImage: isPartnerIncluded ? partnerSignImage : undefined,
    };
  };

  const verifyAgreements = () => {
    const requiredAgreementsIds = (questionnaire.agreements || [])
      .filter((a) => a.required)
      .map((a) => a.id);
    for (let i = 0; i < requiredAgreementsIds.length; i++) {
      if (!FormSubmissionS.isValuePresent(requiredAgreementsIds[i], values)) {
        return false;
      }
    }
    return true;
  };

  const signatureCompleted = () => {
    if (customerSignType === "TEXT_FIELD") {
      return isPartnerIncluded ? sign && partnerSign : sign;
    }
    return isPartnerIncluded
      ? isDefined(signImage) && isDefined(partnerSignImage)
      : isDefined(signImage);
  };

  function accepted() {
    setLoading(true);
    const patchSignatures = signingRequired
      ? patchFormSubmissionValues(formSubmission.id, collectSignatures())
      : Promise.resolve();

    patchSignatures
      .then(() => patchFormSubmission(formSubmission.id, { submitted: true }))
      .then((resp) => {
        if (resp.ok) {
          reload();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const onSubmitClick = () => {
    setShowErrors(false);
    if (!signingRequired) {
      toggle();
      return;
    }
    if (!verifyAgreements()) {
      setShowErrors(true);
      return;
    }
    if (customerContact && !ContactS.isAddressAndPartnerDefined(customerContact)) {
      openCustomerAddressModal({
        documentType: "QUESTIONNAIRE",
        contact: customerContact,
        onFinish: (c) => {
          setCustomerContact(c);
          accepted();
        },
        profileId: resource.profileId,
      });
    } else {
      toggle();
    }
  };

  let styles = {
    container: {
      marginTop: 20,
      marginBottom: 10,
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column",
    },
    sign: {
      fontFamily: "SafiarSignature, Courier",
      fontSize: 32,
      height: 50,
      maxWidth: 250,
    },
  };

  return (
    <>
      {signingRequired && (
        <Agreements
          submitted={formSubmission.lastSubmitted !== null}
          agreements={questionnaire.agreements || []}
          values={values}
          patchSubmissionValue={patchSubmissionValue}
          showErrors={showErrors}
        />
      )}
      <hr /> <br />
      {/*<div>Ich stimme der Datenschutzerklärung zu.</div>*/}
      <div style={styles.container}>
        {signingRequired && (
          <>
            <div>
              Mit folgender Unterzeichnung erklärst Du Dich mit obigen Angaben
              einverstanden.
            </div>
            <Space h="xl" />
            {customerSignType === "TEXT_FIELD" && (
              <div>
                <Group position="center">
                  <TransTextInputField
                    disabled={formSubmission.lastSubmitted !== null}
                    style={{ marginRight: 10 }}
                    inputStyles={styles.sign}
                    onChange={(e) => {
                      handleChange("sign", e.target.value);
                    }}
                    name="sign"
                    value={sign}
                    placeholder={customerDescription}
                    onKeyPress={(event) => {
                      if (/[0-9,.]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {formSubmission.lastSubmitted && (
                    <p>{`Unterzeichnet am: ${moment(customerSignedAt).format(
                      "L"
                    )}`}</p>
                  )}
                </Group>
                {isPartnerIncluded && (
                  <>
                    <Group position="center">
                      <TransTextInputField
                        disabled={formSubmission.lastSubmitted !== null}
                        style={{ marginRight: 10 }}
                        inputStyles={styles.sign}
                        onChange={(e) => {
                          handleChange("partnerSign", e.target.value);
                        }}
                        name="partnerSign"
                        value={partnerSign ? partnerSign : ""}
                        placeholder={getContactName(customerContact.partner)}
                        onKeyPress={(event) => {
                          if (/[0-9,.]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      {formSubmission.lastSubmitted && (
                        <p>{`Unterzeichnet am: ${moment(
                          customerPartnerSignedAt
                        ).format("L")}`}</p>
                      )}
                    </Group>
                    <hr style={{ marginBottom: 40 }} />
                  </>
                )}
              </div>
            )}

            {customerSignType === "BASE64" && (
              <>
                <h5 style={{ marginBottom: 0 }}>
                  {customerDescription}
                </h5>

                {!formSubmission.lastSubmitted && (
                  <ContractDrawSign
                    onChange={(base64) => handleChange("signImage", base64)}
                  />
                )}
                {formSubmission.lastSubmitted && (
                  <>
                    <div
                      style={{
                        marginLeft: 20,
                        alignSelf: "center",
                        height: 50,
                      }}
                    >
                      <Icon value={"BOOKED"} style={{ color: "green" }} />{" "}
                      Unterzeichnet am{" "}
                      <Moment format="L">{customerSignedAt}</Moment>
                    </div>
                    <Paper shadow="xl" mb="xl">
                      <img
                        alt="customerSign"
                        style={{ width: "100%" }}
                        src={signImage}
                      />
                    </Paper>
                  </>
                )}

                {isPartnerIncluded && customerContact.partner && (
                  <>
                    <h5 style={{ marginBottom: 0, marginTop: 10 }}>
                      {getContactName(customerContact.partner)}
                    </h5>

                    {!formSubmission.lastSubmitted && (
                      <ContractDrawSign
                        onChange={(base64) =>
                          handleChange("partnerSignImage", base64)
                        }
                      />
                    )}
                    {formSubmission.lastSubmitted && (
                      <>
                        <div
                          style={{
                            marginLeft: 20,
                            alignSelf: "center",
                            height: 50,
                          }}
                        >
                          <Icon value={"BOOKED"} style={{ color: "green" }} />{" "}
                          Unterzeichnet am{" "}
                          <Moment format="L">{customerPartnerSignedAt}</Moment>
                        </div>
                        <Paper shadow="xl" mb="xl">
                          <img
                            alt="customerPartnerSign"
                            style={{ width: "100%" }}
                            src={partnerSignImage}
                          />
                        </Paper>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}

        {!formSubmission.lastSubmitted && (
          <center>
            <TransButtonPrimaryWithSpinner
              isLoading={loading}
              disabled={(signingRequired && !signatureCompleted()) || loading}
              style={{ height: 50 }}
              onClickHandler={onSubmitClick}
              text={
                signingRequired
                  ? t("questionnaireSignedSubmitButton")
                  : t("questionnaireSubmitButton")
              }
            />
            {signingRequired && !signatureCompleted() && (
              <p
                style={{ marginTop: 10, color: "gray", fontSize: 12 }}
                align="center"
              >
                Der Fragebogen muss vor der Bestätigung von allen Teilnehmern
                unterzeichnet werden.
              </p>
            )}
          </center>
        )}

        {formSubmission.lastSubmitted && (
          <div style={{ marginLeft: 20, alignSelf: "center", height: 50 }}>
            <Icon value={"BOOKED"} style={{ color: "green" }} />{" "}
            <Trans id={"questionnaire.answered-send"} />{" "}
            <Moment fromNow>{formSubmission.lastSubmitted}</Moment>
          </div>
        )}
        <ConfirmDialog
          text={t("questionnaireConfirmText")}
          subject={t("questionnaireConfirmTitle")}
          confirmText={t("questionnaireConfirmButton")}
          cancelText={t("cancelButton")}
          open={show}
          toggle={toggle}
          handler={accepted}
        />
      </div>
      {signingRequired && (
        <>
          <Space h="xl" />
          <ProviderSignature signedAt={resource.lastModified} />
        </>
      )}
    </>
  );
};
